import React from 'react'
import styled from 'styled-components'
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl'
import { breakpoint } from 'src/theme/grid'
import HeaderLoggedIn, {
  HeaderGroup
} from 'src/components/header/HeaderLoggedIn'
import { Page } from 'src/components/Wrappers'
import { Row, SectionBox } from 'src/features/account/components/atoms'
import StockHeader from 'src/features/stocks/components/StockHeader.jsx'
import SearchInput from 'src/features/companies/components/SearchInput'
import OfferList from 'src/features/marketplace/components/OfferList'

const Marketplace = ({ className }) => {
  const intl = useIntl()

  return (
    <Page
      className={className}
      contentPadding={0}
      topBar={
        <HeaderLoggedIn>
          <HeaderGroup>
            <StockHeader>
              {/* fix translations */}
              {intl.formatMessage({
                id: 'marketplace.mainHeader',
                defaultMessage: 'Marketplace'
              })}
            </StockHeader>
          </HeaderGroup>
        </HeaderLoggedIn>
      }
    >
      <Row>
        <SearchWrapper>
          <Title>
            <FormattedMessage
              id='marketplace.bestOffers'
              defaultMessage='Najlepsze oferty partnerskie w e-containers.eu'
            />
          </Title>
          <Description>
            <FormattedMessage
              id='marketplace.description'
              defaultMessage='Przeglądaj i skorzystaj z najlepszych ofert, tylko dla klientów platformy e-containers.eu'
            />
          </Description>
        </SearchWrapper>
      </Row>

      <SectionBox>
        <OfferList />
      </SectionBox>
    </Page>
  )
}

export default styled(Marketplace)`
  ${SectionBox} {
    padding: 2rem 1.2rem 180px 1.2rem;
  }
`

const SearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  backdrop-filter: blur(5px);
  background-color: ${({ theme }) => theme.colors.lightGrey.hex()};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 1rem 10% 3rem;
  box-sizing: border-box;
  ${breakpoint.m`
        padding: 4rem 20% 3rem;
  `}
  & ${SearchInput} {
    margin-top: 0.5rem;
    ${breakpoint.m`
        margin-top: 0;
  `}
  }
`

const Title = styled.div`
  font-size: 1.125rem;
  line-height: 1.78;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 700;
`

const Description = styled.p`
  font-size: 0.875rem;
  line-height: 1.71;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 400;
`

export const NotFound = styled.div`
  font-size: 0.875rem;
  line-height: 1.71;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 400;
  opacity: 0.7;
`
